module.exports = __webpack_public_path__ + "static/media/lottery.d4b1ffe9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/lottery.svg
// module id = 388
// module chunks = 7